import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Chip,
  Box,
  Stack,
  Button,
  CircularProgress
} from "@mui/material";
import EmergencyContactsField from "views/son/components/EmergencyContactsField";
import CPGoogleGeocode from "views/son/components/CPGoogleGeocode";

const UserDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
  title = "Formulario",
  columns = [],
  extraProps = {}
}) => {



  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { minWidth: 800 } }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate onSubmit={onSubmit}>
          <Grid container spacing={2} sx={{ py: 1 }}>
            {columns.map((column) => {
              const commonProps = {
                fullWidth: true,
                size: "small",
                id: column.id,
                label: column.label,
              };

              switch (column.id) {
                case "gender":
                case "secure":
                case "civil_state":
                case "blood_type":
                  return (
                    <Grid key={column.id} item xs={column.xs} sm={column.sm} md={column.md}>
                      <FormControl size="small" fullWidth>
                        <InputLabel id={column.id}>{column.label}</InputLabel>
                        <Select
                          labelId={column.id}
                          label={column.label}
                          id={column.id}
                          value={extraProps[column.id]?.value || ""}
                          onChange={extraProps[column.id]?.onChange}
                        >
                          {column.options?.map((opt) => (
                            <MenuItem key={opt} value={opt}>
                              {opt}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  );

                case "sexually_transmitted_disease":
                case "chronic_degenerative_diseases":
                case "sport":
                case "drug_allergy":
                case "common_allergies":
                case "disabilities":
                  return (
                    <Grid key={column.id} item xs={column.xs} sm={column.sm} md={column.md}>
                      <FormControl size="small" fullWidth>
                        <InputLabel id={`${column.id}-label`}>{column.label}</InputLabel>
                        <Select
                          labelId={`${column.id}-label`}
                          id={`${column.id}-select`}
                          multiple
                          label={column.label}
                          value={
                            Array.isArray(extraProps[column.id]?.value)
                              ? extraProps[column.id]?.value
                              : extraProps[column.id]?.value
                              ? [extraProps[column.id]?.value]
                              : []
                          }
                          onChange={extraProps[column.id]?.onChange}
                          input={<OutlinedInput label={column.label} />}
                          renderValue={(selected) => (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                              {selected.map((val) => (
                                <Chip key={val} size="small" label={val} />
                              ))}
                            </Box>
                          )}
                        >
                          {column.options?.map((opt) => (
                            <MenuItem key={opt} value={opt}>
                              {opt}
                            </MenuItem>
                          ))}
                        </Select>

                      </FormControl>
                    </Grid>
                  );

                case "address_1":
                  return (
                    <Grid key={column.id} item xs={12}>
                      <CPGoogleGeocode setAddress1={extraProps.setAddress1} />
                    </Grid>
                  );

                case "emergency_contacts":
                  return (
                    <Grid key={column.id} item xs={12}>
                      {/*<EmergencyContactsField
                        contacts={extraProps.contacts}
                        setContacts={extraProps.setContacts}
                      />*/}
                    </Grid>
                  );

                default:
                  return (
                    <Grid key={column.id} item xs={column.xs} sm={column.sm} md={column.md}>
                      <TextField
                        {...commonProps}
                        required={column.required}
                        defaultValue={column.defaultValue}
                        disabled={column.disabled}
                        name={column.id}
                        type={column.type}
                        InputLabelProps={column.type === "date" ? { shrink: true } : {}}
                      />
                    </Grid>
                  );
              }
            })}
          </Grid>

          <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button onClick={onClose}>Cancelar</Button>
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              sx={{ mt: 3, mb: 2, position: 'relative' }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Guardar'
              )}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default UserDialog;
